import gql from 'graphql-tag';
import { TransferFragment } from '../fragments';

export default gql`
  query paginationQuery(
    $perPage: Int
    $page: Int
    $filter: TransferCollectionFilters
    $orderBy: TransferOrderInput
  ) {
    transferPagination(
      perPage: $perPage
      page: $page
      filter: $filter
      orderBy: $orderBy
    ) {
      count
      elasticQuery
      items {
        ...TransferFragment
      }
      pageInfo {
        pageCount
        currentPage
      }
    }
  }
  ${TransferFragment}
`;
